var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenCheckBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.99355C0 4.47426 4.47426 0 9.99355 0C15.5128 0 19.9871 4.47426 19.9871 9.99355C19.9871 15.5128 15.5128 19.9871 9.99355 19.9871C4.47426 19.9871 0 15.5128 0 9.99355Z",
    fill: "#00C950"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3285_2681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7052 8.82731C15.9714 10.1335 15.7817 11.4914 15.1678 12.6747C14.5539 13.858 13.553 14.795 12.3318 15.3296C11.1107 15.8641 9.74319 15.9639 8.45739 15.6122C7.17159 15.2606 6.0452 14.4787 5.26608 13.3971C4.48695 12.3155 4.10218 10.9995 4.17592 9.66848C4.24967 8.3375 4.77748 7.07203 5.67133 6.0831C6.56518 5.09417 7.77104 4.44156 9.08782 4.2341C10.4046 4.02665 11.7527 4.27688 12.9073 4.94308",
    stroke: "white",
    strokeWidth: 1.16556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24512 9.41051L9.99345 11.1588L15.8212 5.33105",
    stroke: "white",
    strokeWidth: 1.16556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3285_2681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9867,
    height: 13.9867,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckBg);
export default __webpack_public_path__ + "static/media/green_check_bg.540138048bec40f40cb80a1ecbacf54d.svg";
export { ForwardRef as ReactComponent };